import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/boliger/_components/Description.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/boliger/_components/EstateMenu.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/boliger/_components/ScrollableList.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
